<mat-form-field>
  <input matInput
         [value]="inputValue"
         [type]="type"
         [placeholder]="label"
         (input)="onChange($event)"
         (keydown.enter)="onKeydownEnter($event)"/>
  <mat-icon matSuffix (click)="onAddValue()">add</mat-icon>
</mat-form-field>

<app-form-error-list *ngIf="showErrors"
                     [errorMap]="formControl.errors">
</app-form-error-list>

<div class="selected-values">
  <div class="item-description" *ngFor="let value of selectedValues; let i = index">
    <span class="value">{{value}}</span>
    <button mat-icon-button
            (click)="onRemove(i)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
